<vflow view="auto" [nodes]="nodes" [edges]="edges" />